// import { useState } from "react";
// import { Link } from "react-router-dom";
// import sepatu_kotor from "../../assets/home/sepatu-homepage.png";
// import AOS from "aos";
// import "aos/dist/aos.css";
import maggotBatu from "../../assets/home/maggot batu 1.png";
import textDecore from "../../assets/home/Decore.png";
import DecoreKiri from "../../assets/home/decore kiri.png";

const Homepage = () => {
  // AOS.init();
  // AOS.refresh();
  // AOS.refreshHard();
  return (
    <>
      <img src={DecoreKiri} alt="" className="absolute -top-8 -z-10" />
      <div
        className=" text-left p-8 pt-24 lg:p-44 flex flex-col lg:flex-row"
        id="home"
      >
        <div className="space-y-2 lg:space-y-8 items-center align-middle">
          <p className="text-[#45E6EC] font-bold open-sans">MAKE IT WORTH</p>
          <p className="text-[#181E4B] text-2xl lg:text-7xl font-bold volkhov-bold">
            Berawal dari{" "}
            <span className="relative z-10">
              Sampah
              <img
                src={textDecore}
                alt=""
                className="absolute lg:bottom-2 left-0 lg:h-4 h-[0.3rem] bottom-1 -z-10"
              />
            </span>{" "}
            tumbuh menjadi{" "}
            <span className="relative z-10">
              Harapan
              <img
                src={textDecore}
                alt=""
                className="absolute lg:bottom-2 left-0 lg:h-4 h-[0.3rem] bottom-1 -z-10"
              />
            </span>
          </p>
          <p className="text-sm lg:text-lg open-sans text-[#5E6282]">
            Perusahaan yang dapat mengubah limbah menjadi sesuatu yang lebih
            berguna untuk masa depan
          </p>
        </div>
        <div className="flex relative items-end place-content-end mt-8 lg:mt-0 justify-end lg:w-full">
          <img
            src={maggotBatu}
            alt="maggot"
            className="flex items-end lg:pl-0 lg:h-[600px]"
          />
        </div>
      </div>
    </>
  );
};

export default Homepage;
